var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-wrapper"
  }, [_c('h2', [_vm._v("Personal Information")]), _c('p', [_vm._v("Enter and Update all your Personal Information here.")]), _c('span', [_c('strong', [_vm._v("Rep Code: ")]), _vm._v(" " + _vm._s(_vm.personalInfo.agent_code))]), _c('div', {
    staticClass: "information-form mt-4"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.updateInfo);
            }
          }
        }, [_c('div', {
          staticClass: "form-group"
        }), _c('div', {
          staticClass: "form-group row"
        }, [_c('span', {
          staticClass: "col-xxl-4 col-lg-6 col-md-6 mb-3"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "labelFor": "agent_email",
            "labelName": "Email Address",
            "vmodel": _vm.form.email,
            "formGroupClass": ""
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "email", $event);
            }
          }
        }), _vm.showOtpSectionEmail ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation"
        }, [_c('a', {
          staticClass: "validate-via-otp-link mt-2",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('email');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. ")])]) : _vm._e(), _vm.emailMsg ? _c('div', {
          staticClass: "contact-message-container form-group"
        }, [_c('div', {
          class: ['validate-message mt-2', _vm.emailValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.emailValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.emailValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")])])]) : _vm._e()], 1), _c('span', {
          staticClass: "col-xxl-4 col-xlg-4 col-lg-6 col-md-6 mb-3"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true,
              digits: 10
            },
            "labelFor": "agent_phone1",
            "labelName": "Cell Phone",
            "vmodel": _vm.form.cell_phone,
            "placeholder": "Enter Phone 1 (no dashes eg: 123456789)",
            "formGroupClass": "",
            "inputType": "number",
            "maxlength": "10",
            "inputmode": "numeric",
            "pattern": "\\d*"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "cell_phone", $event);
            }
          },
          nativeOn: {
            "keypress": function keypress($event) {
              return _vm.onlyAllowDigits.apply(null, arguments);
            }
          }
        }), _vm.showOtpSectionPhone ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation"
        }, [_c('a', {
          staticClass: "validate-via-otp-link mt-2",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('phone');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. ")])]) : _vm._e(), _vm.phoneMsg ? _c('div', {
          staticClass: "contacts-message-container form-group"
        }, [_c('div', {
          class: ['validate-message mt-2', _vm.phoneValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.phoneValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.phoneValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.phoneValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.phoneValidationMessage.message) + " ")])])]) : _vm._e()], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "agent_fname",
            "labelName": "First Name",
            "vmodel": _vm.form.first_name,
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "first_name", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "labelFor": "agent_mname",
            "labelName": "Middle Name ",
            "vmodel": _vm.form.middle_name,
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "middle_name", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "agent_lname",
            "labelName": "Last Name",
            "vmodel": _vm.form.last_name,
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "last_name", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "rules": {
              required: false,
              digits: 10,
              clearoutPhone: true
            },
            "labelFor": "agent_phone2",
            "labelName": "Telephone ",
            "vmodel": _vm.form.telephone,
            "placeholder": "Enter Phone 2 (no dashes eg: 123456789)",
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3",
            "inputType": "number"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "telephone", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "labelFor": "fax",
            "labelName": "FAX ",
            "vmodel": _vm.form.fax,
            "placeholder": "Enter Fax (no dashes eg: 123456789)",
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "fax", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "labelFor": "num_800",
            "labelName": "800 Number ",
            "vmodel": _vm.form.num_800,
            "placeholder": "Enter 800 Number (no dashes eg: 123456789)",
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "num_800", $event);
            }
          }
        })], 1), _c('div', {
          staticClass: "clearfix"
        }), _c('div', {
          staticClass: "form-group row"
        }, [_c('input-image', {
          ref: "image",
          attrs: {
            "rules": {
              required: false
            },
            "labelFor": "image",
            "labelName": "Personal Photo Image",
            "vmodel": _vm.image,
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row",
            "imgSrc": _vm.agentImg,
            "imgClass": "downline-upload-img",
            "imageSource": _vm.personalImgSource
          },
          on: {
            "deleteImage": function deleteImage($event) {
              _vm.deleteImage('personal', function () {
                return _vm.removeImageRef('personal');
              });
            },
            "update:vmodel": function updateVmodel($event) {
              _vm.image = $event;
            }
          }
        }), _c('input-image', {
          ref: "businessLogo",
          attrs: {
            "labelFor": "business_logo",
            "labelName": "Business Logo Image",
            "vmodel": _vm.businessLogo,
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row",
            "imgSrc": _vm.businessImage,
            "imgClass": "downline-upload-img",
            "imageSource": _vm.businessImgSource
          },
          on: {
            "deleteImage": function deleteImage($event) {
              _vm.deleteImage('business', function () {
                return _vm.removeImageRef('business');
              });
            },
            "update:vmodel": function updateVmodel($event) {
              _vm.businessLogo = $event;
            }
          }
        })], 1), _vm.personalAddresses ? _c('downline-rep-personal-address-content', {
          attrs: {
            "addresses": _vm.personalAddresses
          }
        }) : _vm._e(), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-xxl-3 col-xl-3 col-lg-3 col-md-6"
        }, [_c('button', {
          staticClass: "univ-btn",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v(" " + _vm._s(_vm.isUpdate ? "Updating..." : "Update") + " ")])])])], 1), _vm.showOtpModal ? _c('DownlineRepOtpVerification', {
          attrs: {
            "identifier": _vm.contactInfo,
            "identifierTypeText": _vm.otpType
          },
          on: {
            "save": _vm.handleVerificationResult,
            "close": _vm.closeOtpModal
          },
          model: {
            value: _vm.showOtpModal,
            callback: function callback($$v) {
              _vm.showOtpModal = $$v;
            },
            expression: "showOtpModal"
          }
        }) : _vm._e()];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }